// extracted by mini-css-extract-plugin
export var readingTime = "cC_kk";